import { createSlot } from "lib/@components/slot/create-slot"

/**
 * Feature-local slot definitions for the share-link "requested information" feature.
 *
 * Both slots are dispatched by the field's `type` as a subtype, e.g.
 * `<RequestedFieldInput.Slot type={field.type} field={field} />`, and each type self-registers a
 * plug in `share-link-fields.runtime.js`. This replaces the previous hardcoded `<Switch>` dispatch
 * so new field types can be added by plugging, without editing the host components.
 *
 * IMPORTANT: import these from here (the feature-local definitions), never from the global
 * `slot-definitions` module.
 */

/** Recipient-facing input control for one requested field (was the `<Switch>` in requested-field-input.js). */
export const RequestedFieldInput = createSlot("RequestedFieldInput")

/** Builder per-type extras shown under a row in the requested-information editor (e.g. choice options, currency code). */
export const RequestedFieldEditor = createSlot("RequestedFieldEditor")

/**
 * Read-only display of a single requested field's *answer*, dispatched by `field.type`, e.g.
 * `<RequestedFieldValue.Slot type={field.type} field={field} value={value} />`. Used by the internal
 * reviewer's regime "Responses" tab to render every recipient's value by type. Each type self-registers
 * a plug in `share-link-fields.runtime.js`; unknown/legacy types fall back to plain text in the host.
 */
export const RequestedFieldValue = createSlot("RequestedFieldValue")
